/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Export_HelperInputs */

const en_us2_profile_editors_export_helper = /** @type {(inputs: Profile_Editors_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A file with everything the app keeps about you:`)
};

const pt_br2_profile_editors_export_helper = /** @type {(inputs: Profile_Editors_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um arquivo com tudo o que o app guarda sobre você:`)
};

const es_419_profile_editors_export_helper = /** @type {(inputs: Profile_Editors_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un archivo con todo lo que la app guarda sobre ti:`)
};

const pt_pt2_profile_editors_export_helper = /** @type {(inputs: Profile_Editors_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ficheiro com tudo o que a app guarda sobre ti:`)
};

const fr_fr2_profile_editors_export_helper = /** @type {(inputs: Profile_Editors_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un fichier avec tout ce que l'app garde sur toi :`)
};

const de_de2_profile_editors_export_helper = /** @type {(inputs: Profile_Editors_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Datei mit allem, was die App über dich speichert:`)
};

const it_it2_profile_editors_export_helper = /** @type {(inputs: Profile_Editors_Export_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un file con tutto quello che l'app conserva su di te:`)
};

/**
* | output |
* | --- |
* | "A file with everything the app keeps about you:" |
*
* @param {Profile_Editors_Export_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_export_helper = /** @type {((inputs?: Profile_Editors_Export_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Export_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_export_helper(inputs)
	if (locale === "es-419") return es_419_profile_editors_export_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_export_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_export_helper(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_export_helper(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_export_helper(inputs)
	return en_us2_profile_editors_export_helper(inputs)
});
export { profile_editors_export_helper as "profile-editors.export_helper" }